export enum AlarmColumnKeys {
  ALARM_TYPE = 'alarmType',
  SELECTION_TYPE = 'selectionType',
  LABELS_OR_EQUIPMENT_TYPES = 'labelsOrEquipmentTypes',
  ALARM_LEVEL = 'alarmLevel',
  ALARM_MESSAGE = 'alarmMessage',
  ACTIONS = 'actions',
  DEFAULT_RECIPIENTS  = 'defaultRecipients',
}
